export const brandLogos = [
  { name: 'TradingView', src: 'https://customer-assets.emergentagent.com/job_heliophant-algo/artifacts/el3w1m9r_tradingview-logo-1030x541-1194306590.webp' }
];
